import { uiSelectedLifeInsuranceStepSelector } from 'embed/selectors/ui'
import * as React from 'react'
import { connect } from 'react-redux'
import { LifeInsuranceViewWithExperiment } from './index'

export interface StoreProps {
  selectedStep
}

const mapStateToProps = (state): StoreProps => ({
  selectedStep: uiSelectedLifeInsuranceStepSelector(state),
})

export const LifeInsuranceContainer = connect(mapStateToProps)(LifeInsuranceViewWithExperiment)
